export const emailValidation = (data: any) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data)
}
export const validatePhone = (phone) => {
    var regx = /^[6-9]\d{9}$/;

    if (regx.test(phone))
        return true
    else
        return false
}

export const negativeNumberStringValidation = (data: any) => {
    if (data == null) {
        return false
    }
    if (data.length) {
        return /^[0-9]+$/.test(data)
    }
}